export enum SupportedLanguages {
  EN = 'EN',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
}

export const SUPPORTED_LANGUAGES: SupportedLanguages[] = Object.values(SupportedLanguages);
export const DEFAULT_LANGUAGE = SupportedLanguages.EN;

type DateFormats = {
  date: string;
  dateWithTime: string;
  advancedDate: string;
  advancedDateTime: string;
};

// Some territories use day-first dates even though the app language stays English.
// Keyed by country code so more territories can be added without touching useLocale.
export const territoryDateFormats: Record<string, DateFormats> = {
  NZ: {
    date: 'DD/MM/YYYY',
    dateWithTime: 'DD/MM/YYYY hh:mmA',
    advancedDate: 'DD/MM/YYYY',
    advancedDateTime: 'DD/MM/YYYY hh:mmA',
  },
};

export const localeDateFormats = {
  [SupportedLanguages.EN]: 'MM/DD/YYYY',
  [SupportedLanguages.DE]: 'DD.MM.YYYY',
  [SupportedLanguages.ES]: 'MM/DD/YYYY',
  [SupportedLanguages.FR]: 'DD/MM/YYYY',
};

export const localeDateWithTimeFormats = {
  [SupportedLanguages.EN]: 'MM/DD/YYYY hh:mmA',
  [SupportedLanguages.DE]: 'DD.MM.YYYY HH:mm',
  [SupportedLanguages.ES]: 'MM/DD/YYYY hh:mmA',
  [SupportedLanguages.FR]: 'DD/MM/YYYY HH:mm',
};

export const localeTimeFormats = {
  [SupportedLanguages.EN]: 'hh:mmA',
  [SupportedLanguages.DE]: 'HH:mm',
  [SupportedLanguages.ES]: 'hh:mmA',
  [SupportedLanguages.FR]: 'HH:mm',
};

export const localeAdvancedDateFormats = {
  [SupportedLanguages.EN]: 'MM/DD/YYYY',
  [SupportedLanguages.DE]: 'DD.MM.YYYY',
  [SupportedLanguages.ES]: 'MM/DD/YYYY',
  [SupportedLanguages.FR]: 'DD/MM/YYYY',
};

export const localeAdvancedTimeFormats = {
  [SupportedLanguages.EN]: 'hh:mmA',
  [SupportedLanguages.DE]: 'HH:mm [Uhr]',
  [SupportedLanguages.ES]: 'hh:mmA',
  [SupportedLanguages.FR]: 'HH:mm',
};

export const localeAdvancedDateTimeFormats = {
  [SupportedLanguages.EN]: 'MM/DD/YYYY hh:mmA',
  [SupportedLanguages.DE]: 'DD.MM.YYYY, HH:mm [Uhr]',
  [SupportedLanguages.ES]: 'MM/DD/YYYY hh:mmA',
  [SupportedLanguages.FR]: 'DD/MM/YYYY, HH:mm',
};
